import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, logout } from "../Utilities/Auth";
import AdminLayout from "../Layout/AdminLayout";

const PrivateRoutes = () => {
	if(isAuthenticated()){
        return <AdminLayout><Outlet/></AdminLayout>
    }
    else{
        logout();
        return <Navigate to="/login" />
    }
};

export default PrivateRoutes;